<template>
  <div id="app" :class="`page ${currentRouteName}-page`">
    <v-app>
      <v-navigation-drawer v-if="authenticated" fixed :clipped="$vuetify.breakpoint.lgAndUp" app v-model="drawer">
        <v-list class="pa-0 py-3">
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <v-icon color="grey darken-2" class="grey lighten-2" large>person</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ profile.fullname }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ profileGroups }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <v-list dense class="pt-0">
          <v-list-tile :to="{name: 'home'}">
            <v-list-tile-action class="pl-2">
              <v-icon>home</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Inicio</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-for="item in navigation" :key="item.title" :to="{ name: item.route}">
            <v-list-tile-action class="pl-2">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="logOut()">
            <v-list-tile-action class="pl-2">
              <v-icon>exit_to_app</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Salir</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>

      <v-toolbar class="elevation-3" v-if="authenticated" color="primary" dark :clipped-left="$vuetify.breakpoint.lgAndUp" fixed app>
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-content>
        <router-view :class="`page ${$route.name}-page`" />
      </v-content>

      <snackbar/>
    </v-app>
  </div>

</template>

<script>
import _ from 'lodash'
import { mapActions, mapState, mapGetters } from 'vuex'
import mutationsMixin from '@/mixins/mutationsMixin'
import Snackbar from '@/components/Snackbar'

export default {
  name: 'app',
  components: {Snackbar},
  mixins: [mutationsMixin],
  beforeCreate () {
    this.$store.commit('initialiseStore')
  },
  data () {
    return {
      drawer: null,
      snackbar: false
    }
  },
  methods: {
    ...mapActions(['logOut'])
  },
  computed: {
    currentRouteName () {
      return this.$route.name
    },
    ...mapState({
      pageTitle: state => state.pageTitle
    }),
    ...mapGetters(['authenticated', 'profile', 'navigation']),
    profileGroups () {
      if (!this.profile || !this.profile.groups) return ''
      return _.join(_.map(this.profile.groups, 'name'), ',')
    }
  }
}
</script>

<style lang="stylus">
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700');
@import './assets/stylus/app.styl';
</style>



// WEBPACK FOOTER //
// src/App.vue